import React from 'react'
import { RiGraduationCapFill } from 'react-icons/ri';
export const Education = () => {
    return (
        <section id='education' className='text-white bg-color-dark grid grid-cols-12 justify-evenly gap-4 border-2 border-color-gray py-10 p-9'>

            <article className='text-3xl font-semibold text-green-800 col-span-12 md:col-start-1 md:col-end-5 flex justify-center items-center text-center gap-4'>
                <RiGraduationCapFill className='min-w-10'/>
                <h2 className=''>EDUCATION</h2>
            </article>

            <article className='col-span-12 md:col-start-5 md:col-end-12 bg-color-ligth-dark p-5'>
                <ul className='custom-bullets list-disc list-inside flex flex-col gap-5'>

                    <div className='flex gap-3 justify-items-start'>
                        <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                        <div className='flex flex-col gap-1'>
                            <div className='text-base sm:text-md lg:text-lg hover:text-green-600'>Information of Technology Analyst: 2023 - present</div>
                            <div className='text-gray-500 text-lg'><i>Tertiary Degree at University of Engineering ORT</i></div>
                        </div>
                    </div>

                    <div className='flex gap-3 justify-items-start'>
                        <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                        <div className='flex flex-col gap-1'>
                            <div className='text-base sm:text-md lg:text-lg hover:text-green-600'>Programmer Analyst: 2023 - present</div>
                            <div className='text-gray-500 text-lg'><i>Associate's degree at University of Engineering ORT</i></div>
                        </div>
                    </div>

                    <div className='flex gap-3 justify-items-start'>
                        <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                        <div className='flex flex-col gap-1'>
                            <div className='text-base sm:text-md lg:text-lg hover:text-green-600'>Web Developer: 2023 - present</div>
                            <div className='text-gray-500 text-lg'><i>Intermediate degree at University of Engineering ORT</i></div>
                        </div>
                    </div>

                    <div className='flex gap-3 justify-items-start'>
                        <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                        <div className='flex flex-col gap-1'>
                            <div className='text-base sm:text-md lg:text-lg hover:text-green-600'>Information of Technology Analyst: 2023 - 2025</div>
                            <div className='text-gray-500 text-lg'><i>Technical Degree with specialization in computer science at School of Computer Science UTU</i></div>
                        </div>
                    </div>

                    <div className='flex gap-3 justify-items-start'>
                        <p className='max-w-11 text-green-600 hidden sm:block'>{'<li>'}</p>
                        <div className='flex flex-col gap-1'>
                            <div className='text-base sm:text-md lg:text-lg hover:text-green-600'>High School Diploma: 2017 - 2022</div>
                            <div className='text-gray-500 text-lg'><i>Dr. Anibal Acosta Estape</i></div>
                        </div>
                    </div>

                </ul>
            </article>

        </section>
    )
}

export default Education
